<section class="flex-column full-height bms-theme-content">
  <vdw-editor-header
    [identifier]="HEADER_IDENTIFIER"
    [menuItems]="[selectedMenuItem]"
    [selectedMenuItem]="selectedMenuItem"
    [isCreateNewPage]="!isEditingShift()"
    [canShowSettings]="false"
    [inProgress]="saving"
    (duplicateEvent)="duplicateShift()"
    (deleteEvent)="deleteShift()"
    (cancelEvent)="navigateBack()"
    (saveEvent)="saveShift(SAVE_TYPE.SAVE)"
    (saveAndCreateNewEvent)="saveShift(SAVE_TYPE.SAVE_AND_CREATE_NEW)"
    (saveAndCloseEvent)="saveShift(SAVE_TYPE.SAVE_AND_CLOSE)"
  ></vdw-editor-header>
  <div class="bms-theme flex-column p-48">
    <form [formGroup]="addShiftForm" class="flex-row gap-16 bms-theme" vdwBp.gt-sm="pr-32 half-width" vdwBp.lt-sm="full-width" appBreadcrumbFormLinker>
      <vdw-string-input
        formControlName="name"
        class="full-width"
        [label]="'GENERAL.NAME' | bmsTranslate"
        [placeholder]="'GENERAL.NAME_PLACEHOLDER' | bmsTranslate: {object: SHIFT_TRANSLATION_KEY | bmsTranslate: {count: 1} | lowercase}"
      >
        <ng-container error>
          <vdw-invalid-form-message [message]="'GENERAL.ERRORS.REQUIRED' | bmsTranslate" [compact]="true" *vdwCanShowErrorForFormControl="'name'; error: 'required'"></vdw-invalid-form-message>
          <vdw-invalid-form-message
            [message]="'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate"
            [link]="getLoadLink()"
            [compact]="true"
            *vdwCanShowErrorForFormControl="'name'; error: 'identifierTaken'"
          ></vdw-invalid-form-message>
          <vdw-invalid-form-message
            [message]="'GENERAL.ERRORS.NON_EMPTY' | bmsTranslate: {label: 'GENERAL.NAME' | bmsTranslate | lowercase}"
            [compact]="true"
            *vdwCanShowErrorForFormControl="'name'; error: 'noSpace'"
          ></vdw-invalid-form-message>
        </ng-container>
      </vdw-string-input>
      <vdw-color-picker-form-input [mode]="LIMITED" [(selectedColor)]="addShiftForm.get('color').value"></vdw-color-picker-form-input>
    </form>
  </div>
</section>
